exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".applicant[data-v-3e3959b5]{border-left:4px solid #1976d2!important}.section-title[data-v-3e3959b5]{align-items:center;border-bottom:1px solid #e5e7eb}.section-subtitle[data-v-3e3959b5]{color:#64748b;font-size:12px;font-weight:400;margin-top:2px}.milestone-heading[data-v-3e3959b5]{color:#0f172a;font-size:14px;font-weight:700;margin-bottom:8px;text-transform:uppercase}.milestone-table[data-v-3e3959b5]{border:1px solid #e5e7eb;border-radius:6px}", ""]);

// exports
